
/**
* Quote JavaScript singleton module
*/

var Quote = (function($) {

  function initQuote() {
    
    $('.quotes__subheading').textyle({
        duration : 0.15,
        delay : 7,
        easing :'swing',
        callback : function(){
            $(this).css({
              transition : '1s',
            });
            //$('.quotes__subtitle').css('color',"#000000");
          }
      });
  }

  

  function init() {

    // return early if no corresponding module present
    if (!$('.home-quotes').length) {
      return;
    }

    //initQuote();

  }

  $(window).scroll(function(){
    inViewport();
});

  function inViewport(){
    $('.home-quotes').each(function(){
        var divPos = $(this).offset().top,
            topOfWindow = $(window).scrollTop();
            console.log(divPos);
            console.log(topOfWindow);
        if( divPos < topOfWindow+800 ){
            initQuote();
            $(this).addClass('visible');
        }
    });

    
}

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Quote.init);
